import React, { useMemo } from 'react';
import { Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import ActionTypes from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import rolesConstants from '@utils/rolesConstants';
import { IDevice } from '@pages/Assets/Inventory/types';

interface CrrBlockUnlockPayloadProps {
  action: ActionTypes.SMS_BLOCK | ActionTypes.SMS_UNBLOCK;
  devices: {
    msisdn: string;
  }[];
}

interface CrrBlockUnlockProps {
  devices: IDevice[];
  isUpload?: boolean;
  form: FormInstance<any>;
}

const useCrrBlockUnlock = ({
  devices,
  isUpload,
  form,
}: CrrBlockUnlockProps): DeviceActionProps => {
  const { t } = useTranslation(['actions-modal', 'device-actions']);
  const smsBlockType = Form.useWatch('smsBlockType', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('block-unlock.action'),
        name: 'smsBlockType',
        showWhenUpload: true,
        content: (
          <Radio.Group optionType="button">
            <Radio value={ActionTypes.SMS_BLOCK}>
              {t('block-unlock.block')}
            </Radio>
            <Radio value={ActionTypes.SMS_UNBLOCK}>
              {t('block-unlock.unlock')}
            </Radio>
          </Radio.Group>
        ),
      },
    ],
    [t],
  );

  const payloadToSend = useMemo(
    (): CrrBlockUnlockPayloadProps => ({
      action: smsBlockType ?? ActionTypes.SMS_BLOCK,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, smsBlockType, isUpload],
  );

  return {
    title: t(`device-actions:labels.common.${rolesConstants.SMS_BLOCK}`),
    steps,
    uploadPosition: 1,
    payloadToSend,
  };
};

export default useCrrBlockUnlock;
